import Divider from '@mui/material/Divider';
import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion'
import { convertToPlain, truncateText } from 'app/shared-components/utils'
import { useSelector } from 'react-redux';
import { createElement } from 'react';
import ProgramLocation from "app/shared-components/organization/ProgramLocation";
import SearchDistance from "app/shared-components/util/SearchDistance";

 

const container = {
    show: {
      transition: {
        staggerChildren: 0.05,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0 },
  };

function generateLink(id, isPublic, organizationUniqueName){
  let link= isPublic ? "/public" : "";
  if (organizationUniqueName) link= link + "/organization/" + organizationUniqueName;
  link= link + "/location/" + id;
  return link;
}

function LocationListItem({ location, basePath, menu, organizationUniqueName, isPublic, noLink}) {
  const link = basePath ? basePath + location.id : noLink ? "" : generateLink(location.id, isPublic, organizationUniqueName);
  let locationText = "";
  if (location?.address) locationText= location.address;
  if (location?.city) locationText= locationText + " " + location.city;
  if (location?.stateProvince) locationText= locationText + " " + location.stateProvince;

  if (!location) return null;
  
  return (
    <Card component={motion.div} variants={item} key={location.id}  className="mb-10 flex flex-col h-full relative">
        {/* Menu moved outside CardActionArea */}
        {menu && (
            <div className="absolute top-6 right-6 z-10" onClick={(e) => e.stopPropagation()}>
                {createElement(menu, {location: location}) }
            </div>
        )}
        <CardActionArea disabled={noLink} component={NavLinkAdapter} to={link} className="flex flex-col items-start align-start h-full">
          <CardHeader
              className="px-24 pt-20 pb-5"
              title={<Typography color="secondary">{location.name}</Typography>}
              subheader={locationText}
          />
          <CardContent className="px-20 pt-0 h-full w-full flex flex-col"></CardContent>
      </CardActionArea>
    </Card>
  );
}


export default LocationListItem;
